import { InputPhoneMaskRU } from '~/components/InputPhoneMask';
import { makeRequest } from '~/clientRequest';
import loc from 'Templates/4tservice/components/service/request.new/.default/lang/ru.json';
import { curry, defaultTo, equals } from 'ramda';
import { InputBase_v2 } from '~/components/InputBase_v2';
import { SelectBase } from '~/components/SelectBase';

const lang = (key) => loc[`s.r.n_${key}`];
const getClientByPhone = curry(makeRequest)('/api/User/getOnPhone/');

export const clientType = {
	Individual: 'INDIVIDUAL',
	Entity: 'ENTITY',
}

export const ServiceRequestNewFormClientInfo = {
	name: 'ServiceRequestNewFormClientInfo',
	props: {
		initialClient: Object,
	},
	data: ({ initialClient }) => (console.log(initialClient), {
		type: clientType.Individual,
		phone: defaultTo('', initialClient.phone),
		name: defaultTo('', initialClient.name),
		entity: null,
		isNameLocked: false,
	}),
	computed: {
		isEntity: function() {
			return this.type === clientType.Entity;
		},
		isNameEmpty: function() {
			return equals('', this.name);
		},
	},
	methods: {
		updateClientNameByPhone() {
			getClientByPhone(this.phone)
				.then(name => {
					if (name) {
						this.name = name;
						this.isNameLocked = true;
					} else {
						this.isNameLocked = false;
					}
				});
		},
	},
	watch: {
		type: {
			handler: function() {
				this.$emit('typeChange', this.type)
			},
			immediate: true,
		},
	},
	render(h) {
		return (
			<div>
				<SelectBase
					class="mb-6"
					vOn:change={ ({ currentTarget }) => this.type = currentTarget.value }
					required
					name="CLIENT_TYPE"
					label={ lang('CLIENT_TYPE') }
				>
					<option selected value={clientType.Individual}>
						{ lang(clientType.Individual) }
					</option>
					<option value={clientType.Entity}>
						{ lang(clientType.Entity) }
					</option>
				</SelectBase>

				<div class="flex mb-6">
					<label class="input-block">
						<InputPhoneMaskRU
							type="text"
							class="phone-mask input-block__input"
							placeholder="+7 000 000-00-00"
							required
							name="PHONE"
							autocomplete="off"
							value={ this.phone }
							onInput={ ({ currentTarget }) => this.phone = currentTarget.value }
						/>
						<span class="label input-block__label">{ lang('PHONE') }</span>
					</label>
					<button
						class="button button_theme_secondary clientRequestBtn align-self-end ml-4"
						type="button"
						title={ lang('SEARCH_CLIENT') }
						onClick={ this.updateClientNameByPhone }
					>
						<svg class="icon" role="img" viewBox="0 0 512 512">
							<path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
						</svg>
					</button>
				</div>

				<InputBase_v2
					ref="clientName"
					class="mb-6"
					type="text"
					name="NAME"
					autocomplete="off"
					readonly={ this.isNameLocked }
					required
					label={ lang('NAME') }
					error-message={ 'Заполните ФИО клиента' }
					vModel_trim={ this.name }
				/>

				<InputBase_v2
					class="mb-6"
					type="text"
					name="CONTACT_ENTITY"
					disabled={ !this.isEntity }
					label={ lang('CONTACT_ENTITY') }
					vModel_trim={ this.entity }
				/>
			</div>
		);
	}
}
